// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"64":"f1d3c725","146":"f1d3c725","331":"081737ff","446":"75c86954","475":"8c03ffe4","476":"2cbb6cb8","572":"5b7e823a","632":"7c0ab019"}[chunkId] + ".chunk.css";
};